/* assets/section-product-scroller.js — lego L64 V9's script, carried from the
   locked home composite creative/web-legos/legos/L59-home-composed/v13.html
   (D-071), wi-2026-1119. ONE change: the lego looked up its single root with
   document.querySelector; here every scroller on the page is wired on its own
   root (and re-wired when the theme editor reloads the section). */
(function () {

/* The spotlight, the circle, the drag and the phone nudge. The swipe and the snap
   are CSS. Nothing moves on its own except the one-time phone nudge, which never
   runs under reduced motion and stops for good at the first touch. */
function l64Wire(root) {
  if (!root || root.dataset.l64Wired) return;
  root.dataset.l64Wired = "1";
  const rail = root.querySelector(".rail");
  const track = rail.querySelector(".track");
  const real = [...track.children];
  const N = real.length;
  const COPIES = 2;                                   // sets of copies on EACH side

  // ---- THE CIRCLE: decorative copies around the real six ----
  const copySet = () => real.map((li) => {
    const c = li.cloneNode(true);
    c.setAttribute("aria-hidden", "true");
    c.dataset.copy = "";
    c.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
    const a = c.querySelector(".card");
    a.setAttribute("tabindex", "-1");
    ["data-lp", "data-product-handle", "aria-labelledby", "aria-describedby"].forEach((k) => a.removeAttribute(k));
    return c;
  });
  for (let k = 0; k < COPIES; k++) { track.prepend(...copySet()); track.append(...copySet()); }

  const slots = [...track.children];                 // (2 x COPIES + 1) x N
  const cards = slots.map((s) => s.querySelector(".card"));
  const FIRST = COPIES * N;                          // index of the real Master Blend
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
  let active = -1, target = null, queued = false, settle = 0, dragging = false;

  const centreOf = (i) => slots[i].offsetLeft + slots[i].offsetWidth / 2;
  const leftFor = (i) => centreOf(i) - rail.clientWidth / 2;
  const setW = () => centreOf(N) - centreOf(0);
  const mod = (i) => ((i % N) + N) % N;
  const num = (name, dflt) => parseFloat(getComputedStyle(root).getPropertyValue(name)) || dflt;

  function jump(left) {                              // an instant move, never animated
    rail.style.scrollBehavior = "auto";
    rail.scrollLeft = left;
    rail.style.scrollBehavior = "";
  }

  // ---- THE SPOTLIGHT ----
  function draw() {
    queued = false;
    const min = num("--l64-min", 0.65), pull = num("--l64-pull", 1);
    const step = centreOf(1) - centreOf(0);
    const mid = rail.scrollLeft + rail.clientWidth / 2;
    let best = 0, bestD = Infinity;
    slots.forEach((slot, i) => {
      const d = (centreOf(i) - mid) / step;
      const D = Math.abs(d);
      const s = 1 - (1 - min) * Math.min(D, 1);
      const g = D <= 1 ? D - (1 - min) * D * D / 2 : (1 + min) / 2 + min * (D - 1);
      const c = cards[i];
      c.style.setProperty("--l64-s", s.toFixed(4));
      c.style.setProperty("--l64-x", ((Math.sign(d) * g * pull - d) * step).toFixed(2) + "px");
      c.style.setProperty("--l64-near", (1 - Math.min(D, 1)).toFixed(3));
      c.style.setProperty("--l64-far", (1 - Math.min(Math.max(D - 1, 0), 1)).toFixed(3));
      c.style.zIndex = String(Math.max(1, 10 - Math.round(D)));
      if (D < bestD) { bestD = D; best = i; }
    });
    if (best !== active) { active = best; root.dataset.active = real[mod(best)].dataset.family; }
  }
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(draw); } };

  // ---- at rest, step onto the real set by whole set widths (identical picture) ----
  function normalise() {
    if (dragging || hintRaf) return;
    target = null;
    draw();
    const sets = Math.floor((active - FIRST) / N);   // how many sets away from the real six
    if (sets !== 0) { jump(rail.scrollLeft - sets * setW()); draw(); }
  }
  const onScroll = () => { queue(); clearTimeout(settle); settle = setTimeout(normalise, 160); };

  function go(i) {
    // Heading past the copies (a long run of presses mid-scroll)? Rebase first: move
    // the rail, the target and the centre by whole sets. Same picture, so it is
    // invisible, and the arrows never meet an end however fast they are pressed.
    const k = Math.floor((i - FIRST) / N);
    if (Math.abs(k) >= COPIES) {
      jump(rail.scrollLeft - k * setW());
      i -= k * N; active -= k * N;
    }
    target = i;
    rail.scrollTo({ left: leftFor(i), behavior: reduce.matches ? "auto" : "smooth" });
  }
  const from = () => (target ?? active);

  root.querySelectorAll(".arrow").forEach((a) => a.addEventListener("click", () => go(from() + Number(a.dataset.dir))));
  rail.addEventListener("keydown", (e) => {
    if (e.target !== rail) return;
    if (e.key === "ArrowRight") { e.preventDefault(); go(from() + 1); }
    if (e.key === "ArrowLeft") { e.preventDefault(); go(from() - 1); }
  });
  // a neighbour is a step, not a door: the first press centres it
  let justDragged = false;
  cards.forEach((c, i) => c.addEventListener("click", (e) => {
    if (justDragged) { e.preventDefault(); return; }
    if (i !== active) { e.preventDefault(); go(i); }
  }));
  slots.forEach((slot, i) => slot.addEventListener("focusin", () => { if (i !== active) go(i); }));

  // ---- DRAG with a mouse (touch and trackpads scroll natively) ----
  rail.addEventListener("pointerdown", (e) => {
    if (e.pointerType !== "mouse" || e.button !== 0) return;
    e.preventDefault();                              // no link drag, no text selection
    const x0 = e.clientX, s0 = rail.scrollLeft, a0 = active;
    let moved = false;
    const move = (ev) => {
      const dx = ev.clientX - x0;
      if (!moved && Math.abs(dx) < 5) return;
      if (!moved) { moved = dragging = true; rail.classList.add("is-dragging"); rail.style.scrollBehavior = "auto"; }
      rail.scrollLeft = s0 - dx;
    };
    const up = (ev) => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
      if (!moved) return;
      dragging = false;
      rail.classList.remove("is-dragging");
      rail.style.scrollBehavior = "";
      justDragged = true; setTimeout(() => { justDragged = false; }, 0);
      // settle on the nearest product; a short flick that did not pass a neighbour still moves one
      const flick = ev.clientX - x0;
      go(active === a0 && Math.abs(flick) > 40 ? active - Math.sign(flick) : active);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  });

  // ---- THE PHONE NUDGE: once, when the section first comes into view ----
  // It SCROLLS the rail (snap off for its duration) rather than transforming the track:
  // a transformed track moves the snap areas, the rail re-snaps under it and the cards
  // re-draw against the wrong offset (the first build's stacked left edge). Scrolling
  // keeps one geometry: the spotlight redraws every frame, the next product swells a
  // little as it approaches, and the rail lands back on exactly the pixel it left.
  let hintRaf = 0, hinted = false, home = 0;
  const endHint = () => {
    if (!hintRaf) return;
    cancelAnimationFrame(hintRaf); hintRaf = 0;
    rail.classList.remove("is-hinting"); rail.style.scrollBehavior = "";
  };
  const stopHint = () => { hinted = true; if (hintRaf) { endHint(); jump(home); } };
  ["touchstart", "pointerdown", "wheel", "keydown"].forEach((t) => rail.addEventListener(t, stopHint, { passive: true }));
  root.querySelectorAll(".arrow").forEach((a) => a.addEventListener("pointerdown", stopHint));
  function playHint() {
    const amp = Math.round(slots[0].offsetWidth * 0.16);        // about 40px on a phone
    const DUR = 2600, CYCLES = 2;
    home = rail.scrollLeft;
    rail.classList.add("is-hinting"); rail.style.scrollBehavior = "auto";
    const t0 = performance.now();
    const frame = (now) => {
      const p = Math.min((now - t0) / DUR, 1);
      // two eased out-and-back swells: 0 -> amp -> 0, twice (a raised cosine)
      rail.scrollLeft = home + amp * (1 - Math.cos(p * CYCLES * 2 * Math.PI)) / 2;
      if (p < 1) hintRaf = requestAnimationFrame(frame);
      else { endHint(); jump(home); hinted = true; }
    };
    hintRaf = requestAnimationFrame(frame);
  }
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((en) => en.isIntersecting)) return;
      io.disconnect();
      if (hinted || reduce.matches || !window.matchMedia("(max-width: 749px)").matches) return;
      setTimeout(() => { if (!hinted) playHint(); }, 600);
    }, { threshold: 0.6 });
    io.observe(root);
  }

  rail.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => { jump(leftFor(FIRST + mod(active))); queue(); });
  jump(leftFor(FIRST));                              // open on the real Master Blend
  draw();
}
function l64All() { document.querySelectorAll("section.lego-L64-v9").forEach(l64Wire); }
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", l64All); else l64All();
document.addEventListener("shopify:section:load", l64All);
})();
